<template>
<div>
  <div class="devices">
    <v-container>
      <v-row justify="space-around">
        <v-card width="350" dark class="card">
          <v-img
            src="../assets/RMX1971.jpg"
            style="margin-top:3%"
          >
          </v-img>

          <v-card-text>
            <div class="font-weight-bold ml-8 mb-2">
              Realme 5 Pro (RMX1971)
            </div>

            <v-timeline
              align-top
              dense
            >
              <v-timeline-item small>
                <div>
                  <div class="font-weight-normal">
                    <strong>Processor : </strong> Snapdragon 712
                  </div>
                </div>
              </v-timeline-item>
              <v-timeline-item small>
                <div>
                  <div class="font-weight-normal">
                    <strong>Released on : </strong> August 2019
                  </div>
                </div>
              </v-timeline-item>
              <v-timeline-item small>
                <div>
                  <div class="font-weight-normal">
                    <strong>Ram : </strong>  4/6/8 GB RAM (LPDDR4X 1866 MHz dual-channel)
                  </div>
                </div>
              </v-timeline-item>
              <v-timeline-item small>
                <div>
                  <div class="font-weight-normal">
                    <strong>Internal : </strong> 64/128 GB UFS 2.1
                  </div>
                </div>
              </v-timeline-item>
              <v-timeline-item small>
                <div>
                  <div class="font-weight-normal">
                    <strong>Shipped Android Version : </strong> 9 with ColorOS 6.0
                  </div>
                </div>
              </v-timeline-item>
              <v-timeline-item small>
                <div>
                  <div class="font-weight-normal">
                    <strong>Battery : </strong> Non-removable Li-Po 4035 mAh
                  </div>
                </div>
              </v-timeline-item>
              <v-timeline-item small>
                <div>
                  <div class="font-weight-normal">
                    <strong>Back Cameras : </strong> 4
                  </div>
                </div>
              </v-timeline-item>
              <v-timeline-item small>
                <div>
                  <div class="font-weight-normal">
                    <strong>Front Cameras : </strong> 1
                  </div>
                </div>
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
        </v-card>
      </v-row>
    </v-container>
    <v-container class="builds">
      <v-row justify="space-around">
        <label>Select Build Type:</label>
        <v-select
        v-model="type_values" :items="type" item-text="title"  item-value="title" cache-items class="mx-4"
        hide-no-data hide-details dark solo @change="selectedbuildtype()"></v-select>
        <label style="margin-top:2%;" v-if="roms">Select Android Version:</label>
        <v-select v-if="roms"
        v-model="version_values" :items="version" item-text="title"  item-value="title" cache-items class="mx-4"
        hide-no-data hide-details solo @change="selectedversion()" dark></v-select>
        <label style="margin-top:2%;" v-if="roms">Select Build Tag:</label>
        <v-select v-if="roms"
        v-model="tag_values" :items="tag" item-text="title"  item-value="title" cache-items class="mx-4"
        hide-no-data hide-details dark solo @change="selectedbuildtag()"></v-select>
        <div v-for="latestbuild in buildsdata" :key="latestbuild">
        <v-card
            v-if="(roms && 
            ((a11 && latestbuild.version=='Android 11') || (a12 && latestbuild.version=='Android 12') || (a11 && a12 && (latestbuild.version=='Android 12' || latestbuild.version=='Android 11'))) &&
            ((official && latestbuild.tag=='Official') || (unofficial && latestbuild.tag=='UnOfficial') || (official && unofficial && (latestbuild.tag=='UnOfficial' || latestbuild.tag=='Official'))))
            || kernel || recovery"
            class="mx-auto build"
            max-width="400"
            min-height="275"
            outlined
            dark
            @click="goto_page(latestbuild.type,latestbuild.version,latestbuild.device,latestbuild.maintainer,latestbuild.name)"
          >
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="text-h5">
                  {{ latestbuild.name }}
                </v-list-item-title>
                <v-list-item-subtitle><strong>Device : </strong> 
                  <i v-if="latestbuild.device == 'RMX1971'">Realme 5 Pro</i>
                  <i v-if="latestbuild.device == 'r5x'">Realme 5 Series</i>
                  <i v-if="latestbuild.device == 'EVEN'">Realme C25 Series</i>
                </v-list-item-subtitle>
                <v-list-item-subtitle><strong>By : </strong>  
                  <i>{{ latestbuild.maintainer }}</i>
                </v-list-item-subtitle>
                <v-list-item-subtitle><strong>Build Date : </strong> 
                  <i>{{ latestbuild.build_date }}</i>
                </v-list-item-subtitle>
                <v-list-item-subtitle><strong>Version : </strong> 
                  <i>{{ latestbuild.version }}</i>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="latestbuild.type!='kernel'"><strong>Tag : </strong> 
                  <i>{{ latestbuild.tag }}</i>
                </v-list-item-subtitle>
                <v-list-item-subtitle><strong>Download : </strong> 
                  <i><a :href="latestbuild.download">{{ latestbuild.name }}</a></i>
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-avatar
                tile
                size="80"
                color="grey"
              ><img :src="latestbuild.logo"></v-avatar>
            </v-list-item>

            <v-card-actions>
              <v-btn
                outlined
                rounded
                text
                class="foota"
                v-if="latestbuild.type == 'rom' && latestbuild.version == 'Android 12'"
                :href="latestbuild.device+'/'+latestbuild.maintainer+'/android12/'+latestbuild.name"
              >
                Explore More
              </v-btn>
              <v-btn
                outlined
                rounded
                text
                class="foota"
                v-if="latestbuild.type == 'rom' && latestbuild.version == 'Android 11'"
                :href="latestbuild.device+'/'+latestbuild.maintainer+'/android11/'+latestbuild.name"
              >
                Explore More
              </v-btn>
              <v-btn
                outlined
                rounded
                text
                class="foota"
                v-if="latestbuild.type != 'rom'"
                :href="latestbuild.device+'/'+latestbuild.maintainer+'/'+latestbuild.name"
              >
                Explore More
              </v-btn>
            </v-card-actions>
        </v-card>
        </div>
        <div style="text-align:center;margin-top:2%" v-if="loadingdata && buildsdata.length == 0">
          <v-progress-circular
            :rotate="180"
            :size="100"
            :width="15"
            :value="value"
            color="blue"
          >
            {{ value }}
          </v-progress-circular>
        </div>
        <div v-if="nodata" style="text-align:center;margin-top:2%">
          <img src="../assets/404.png" alt="404(Not Found)">
            <h1>404</h1>
            <p>No Data Found</p>
        </div>
      </v-row>
    </v-container>
  </div>
</div>
</template>

<script>
import axios from 'axios';

  export default {
    name: 'Realme5Pro',
    components: {
    },
    data: () => ({
        roms: true,
        kernel: false,
        recovery: false,
        a11: false,
        a12: true,
        official: true,
        unofficial: true,
        buildsdata: [],
        loadingdata: false,
        nodata: false, 
        type: [{'title' : 'Rom'},{'title' : 'Kernel'},{'title' : 'Recovery'}],
        type_values: 'Rom',
        version: [{'title' : 'All'},{'title' : 'Android 11'},{'title' : 'Android 12'}],
        version_values: 'Android 12',
        tag: [{'title' : 'All'},{'title' : 'Official'},{'title' : 'Unofficial'}],
        tag_values: 'All',
        interval: {},
        value: 10
    }),
    beforeDestroy () {
      clearInterval(this.interval)
    },
    mounted () {
      this.interval = setInterval(() => {
        if (this.value === 100) {
          return (this.value = 0)
        }
        this.value += 10
      }, 1000)
    },
    created () {
        this.getrmx1971data();
    },

    methods: {
        getrmx1971data() {
            this.buildsdata = []
            this.loadingdata = true
            let data = {
                device: 'RMX1971',
            };
            let config = {
                method : 'post',
                url : `https://kharame-devices.herokuapp.com/getBuildsPerDevice`,
                data: data
            };
            axios(config)
            .then((response) => {
                this.rmx1971data = response.data.message;
                if (this.roms) {
                    this.buildsdata = this.rmx1971data['roms'];
                } else if (this.kernel) {
                    this.buildsdata = this.rmx1971data['kernels'];
                } else {
                    this.buildsdata = this.rmx1971data['recoveries'];
                }
                if (this.buildsdata) {
                      this.loadingdata = false;
                      this.nodata = false;
                  } else {
                      setTimeout(() => { this.loadingdata = false; }, 1000);
                      setTimeout(() => { this.nodata = true; }, 1000);
                  }
            })
        },
        selectedversion() {
          if (this.version_values == 'All'){
            this.a11 = true;
            this.a12 = true;
          }
          if (this.version_values == 'Android 11'){
            this.a11 = true;
            this.a12 = false;
          }
          if (this.version_values == 'Android 12'){
            this.a11 = false;
            this.a12 = true;
          }
          this.getrmx1971data();
        },
        selectedbuildtag() {
          if (this.tag_values == 'All'){
            this.official = true;
            this.unofficial = true;
          }
          if (this.tag_values == 'Official'){
            this.official = true;
            this.unofficial = false;
          }
          if (this.tag_values == 'Unofficial'){
            this.official = false;
            this.unofficial = true;
          }
          this.getrmx1971data();
        },
        selectedbuildtype() {
          if (this.type_values == 'Rom'){
            this.roms = true;
            this.kernel = false;
            this.recovery = false;
          }
          if (this.type_values == 'Kernel'){
            this.roms = false;
            this.kernel = true;
            this.recovery = false;
          }
          if (this.type_values == 'Recovery'){
            this.roms = false;
            this.kernel = false;
            this.recovery = true;
          }
          this.getrmx1971data();
        },
        goto_page(type,version,device,maintainer,name) {
          if (type == 'rom' && version == 'Android 12') {
            window.location.href = device+'/'+maintainer+'/android12/'+name;
          } else if (type == 'rom' && version == 'Android 11') {
            window.location.href = device+'/'+maintainer+'/android11/'+name;
          } else if (type != 'rom') {
            window.location.href = device+'/'+maintainer+'/'+name
          }
        }
    },
  }
</script>
<style scoped>
.devices {
  margin-top:8%;
  margin-bottom: 2%;
  display:flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  width:85%;
}
.card {
  background: rgba(23,25,33,255) !important;
  box-shadow: 0px 5px 5px 1px rgba(0,0,0,0.6) !important;
}
.build {
  margin: 2%;
  background: rgba(23,25,33,255) !important;
  box-shadow: 0px 5px 5px 1px rgba(0,0,0,0.6) !important;
}
.v-list-item__content .v-list-item__subtitle{
  color :whitesmoke !important;
  font-size: 14px;
  padding:1%;
}
@media (max-width: 1000px) {
  .devices {
    margin-top: 10%;
  }
  .builds {
    margin-bottom: 5%;
  }
}
@media (max-width: 550px) {
  .devices {
    display: block;
    margin-top: 18%;
  }
  .builds {
    margin-top : 12%;
    margin-bottom: 12%;
  }
}
</style>